import { isPast, toDate } from 'date-fns';

const isPastDeal = (endDate: string | undefined): boolean => (
  endDate
    ? isPast(toDate(Date.parse(endDate)))
    : false
);

export { isPastDeal };
